import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderService } from 'src/app/service/loader.service';
import { UserService } from 'src/app/service/user.service';
import { BaseComponent } from 'src/app/shared/components/base.component';

@Component({
  selector: 'app-implantation-order-popup',
  templateUrl: './implantation-order-popup.component.html',
  styleUrls: ['./implantation-order-popup.component.scss']
})
export class ImplantationOrderPopupComponent extends BaseComponent implements OnInit {

  items = [];
  chart: any;
  fromDate: any;
  toDate: any;
  reportPeriod: any;
  year: any;
  month: any;
  week: any;

  currentYear = new Date().getFullYear();
  defaultChartData: any = null;
  defaultChartDataLength: number = null;

  // public barChartOptions: any = {
  //   scaleShowVerticalLines: false,
  //   responsive: true
  // };
     public barChartOptions = {
    scales: {
      xAxes: [{ 
        categoryPercentage: 0.7,   // default ~0.8; lower makes bars wider
        barPercentage: 0.9,
        ticks: { beginAtZero: true }
      }]
      // ,
      // yAxes: [{ ticks: { beginAtZero: true } }]
    },
    elements: {
      rectangle: {
        minBarLength: 10,
        borderWidth: 1
      }
    },
    // ... tooltips/hover from above
  };

  chartData: number[] = [];
  public barChartLabels: string[] = []
  public barChartData: any[] = [];
  public barChartType: string = 'bar';
  public barChartLegend: boolean = false;
  public barChartColors: Array<any> = [];

  constructor(public activeModal: NgbActiveModal, private loaderService: LoaderService, private userService: UserService,) {
    super();
  }

  closeActiveModal(value) {
    this.activeModal.close(true);
  }

  ngOnInit(): void {

    this.CreateChartSelectedDateWise();

  }

  ngAfterViewInit() {
    // this.CreateChartSelectedDateWise();
    this.CreateChart();
  }

  CreateChart() {
    //console.log(this.doughnutColor);

    for (let i = 0; i < this.defaultChartData.length; i++) {
      this.barChartColors = [{ backgroundColor: '#74acac' }];
      this.barChartLabels.push(this.defaultChartData[i].implementationName)
      this.chartData.push(this.defaultChartData[i].orderCount)
    }
    this.barChartData = [{ data: this.chartData, label: (new Date()).getFullYear() }];

  }

  CreateChartSelectedDateWise() {
    // console.log("this.items");
    // console.log(this.items);
    this.loaderService.show();
    if (this.items.length > 0) {
      this.userService.GetDashboardPopupReport(this.items[0]["reportFromDate"], this.items[0]["reportToDate"], this.items[0]["period"], this.items[0]["year"], this.items[0]["month"], "GetImplantationOrderReport", this.items[0]["implementation"], this.items[0]["service"]).subscribe(
        ress => {
          this.loaderService.hide();
          if (ress.successed) {
            var data = ress.data;

            function getColorForImpl(implIndex: number) {
              const hue = (implIndex * 50) % 360;
              const base = `hsl(${hue}, 65%, 55%)`;
              const hover = `hsl(${hue}, 65%, 40%)`;
              return { base, hover };
            }

            if (data.dashboardPopupBarChart[0].subColumnName === "undefined" || (data.dashboardPopupBarChart[0].subColumnName === null && data.dashboardPopupBarChart[0].weekRange === null)) {
              this.barChartData = [];
              this.barChartColors = [];
              this.barChartLabels = [];
              this.chartData = [];
              const rawData = data.dashboardPopupBarChart;
              const years = Array.from(new Set(rawData.map((x: any) => x.columnName)));
              const implementations = Array.from(new Set(rawData.map((x: any) => x.implementationName)));
              this.barChartLabels = years as string[];
              //const color = "#74acac";
              this.barChartData = implementations.map((impl, idx) => {
                const color = getColorForImpl(idx);
                return {
                  label: impl,
                  data: years.map((yr) => {
                    const row = rawData.find(
                      (r) =>
                        r.columnName === yr &&
                        r.implementationName === impl
                    );
                    return row ? +row.columnValue : 0;
                  }),
                  backgroundColor: color.base,
                  hoverBackgroundColor: color.hover,
                };
              });
              this.barChartLegend = true;
            }



            else if (data.dashboardPopupBarChart[0].weekRange !== "undefined" && data.dashboardPopupBarChart[0].weekRange !== null) {
              this.barChartData = [];
              this.barChartColors = [];
              this.barChartLabels = [];
              this.chartData = [];
              this.barChartLegend = true;
              const rawData = data.dashboardPopupBarChart;

              const weeks = Array.from(new Set(rawData.map((x: any) => x.columnName)));
              const implementations = Array.from(new Set(rawData.map((x: any) => x.implementationName)));


              weeks.sort((a: string, b: string) => {
                const numA = parseInt(a.replace(/\D/g, ""), 10);
                const numB = parseInt(b.replace(/\D/g, ""), 10);
                return numA - numB;
              });


              this.barChartLabels = weeks.map((w) => {
                const range = rawData.find((r) => r.columnName === w)?.weekRange || "";
                return `${w} (${range})`;
              });



              this.barChartData = implementations.map((impl, idx) => {
                const color = getColorForImpl(idx);
                return {
                  label: impl,
                  data: this.barChartLabels.map((label) => {
                    const week = label.split(" (")[0];
                    const row = rawData.find(
                      (r) =>
                        r.columnName === week &&
                        r.implementationName === impl
                    );
                    return row ? +row.columnValue : 0;
                  }),
                  backgroundColor: color.base,
                  hoverBackgroundColor: color.hover,
                };
              });
            }




            else {
              this.barChartData = [];
              this.barChartColors = [];
              this.barChartLabels = [];
              this.chartData = [];

              interface RawData {
                columnName: string;
                subColumnName: string;
                implementationName: string;
                columnValue: number | string;
              }

              const rawData: RawData[] = (data.dashboardPopupBarChart || []) as RawData[];

              const monthOrder = [
                "January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"
              ];
              const months = [...monthOrder];
              const implementations = Array.from(new Set(rawData.map(r => r.implementationName))).sort();
              const years = Array.from(new Set(rawData.map(r => r.columnName))).sort();

              function getData(year: string, month: string, impl: string) {
                const matches = rawData.filter(r =>
                  String(r.columnName) === String(year) &&
                  String(r.subColumnName) === String(month) &&
                  String(r.implementationName) === String(impl)
                );
                return matches.reduce((acc, r) => acc + (Number(r.columnValue) || 0), 0);
              }




              const datasets: any[] = [];
              if (implementations.length > 1) {
                implementations.forEach((impl, idx) => {
                  const colors = getColorForImpl(idx);
                  years.forEach((year, yIdx) => {
                    const dataForMonths = months.map(m => getData(year, m, impl));
                    //console.log("dataForMonths", dataForMonths);
                    if (dataForMonths.every(v => v === 0)) return;

                    datasets.push({
                      label: `${impl} (${year})`,
                      implLabel: impl,
                      year,
                      data: dataForMonths,
                      backgroundColor: colors.base,
                      hoverBackgroundColor: colors.hover,
                      stack: year,
                      barPercentage: 0.8,
                      categoryPercentage: 0.9,
                    });
                  });
                });
              }
              else {
                implementations.forEach((impl, idx) => {
                  years.forEach((year, yIdx) => {
                    const colors = getColorForImpl(yIdx);
                    const dataForMonths = months.map(m => getData(year, m, impl));
                    //console.log("dataForMonths", dataForMonths);
                    if (dataForMonths.every(v => v === 0)) return;

                    datasets.push({
                      label: `${impl} (${year})`,
                      implLabel: impl,
                      year,
                      data: dataForMonths,
                      backgroundColor: colors.base,
                      hoverBackgroundColor: colors.hover,
                      stack: year,
                      barPercentage: 0.8,
                      categoryPercentage: 0.9,
                    });
                  });
                });

              }
              // console.log("datasets");
              // console.log("datasets snapshot", JSON.parse(JSON.stringify(datasets)));


              this.barChartLabels = months;
              this.barChartData = datasets;

            }
            // console.log("this.barChartData");
            //console.log(this.barChartData);
          } else {
            this.toastrAlertService.errorToastr(ress.errorMessage);
          }
        },
        error => {
          this.loaderService.hide();
          if (typeof error.error !== "undefined") {
            this.toastrAlertService.errorToastr(this.appTranslateService.getTranslate('generalError'));
          }
        }
      );
    }

    this.barChartData = [];
    this.chartData = [];
    this.barChartLabels = [];
    this.barChartData = [];

    this.items = [];
    this.loaderService.hide();

  }




 
  public chartClicked(e: any): void {
    //console.log(e);
  }

  public chartHovered(e: any): void {
    //console.log(e);
  }

  // onSelectAll(items: any) {
  //   //console.log(items);
  // }

  // onItemSelect(item: any) {
  //   // console.log(item);
  // }
  // SelectedPeriod() {

  // }


  addItem(newItem: string) {
    //  console.log("addItem");
    //  console.log(newItem);
    this.items.push(newItem);
    console.log(this.items);
    this.CreateChartSelectedDateWise()
  }

}
